module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAYAAADlep81AAAAAXNSR0IArs4c6QAAANdJREFUSA3tlkEKwjAQRU3wEsVDuOleL6LbkJ2C4h1EcJl2qwuvUfcFTyG5ReL/kq5n1aaLDJSZZkL+YzKQUQuYc24Fd1NKbWKMFdemMmh6aL6hd7LWflWC6bFw11o/jTF+KhjqtG1bhRB2CI/4agK9EHxAd4XPZk3TXCC+1rwmViYbSRIGxwPhlv0Tc8MM+mTRw89cfAGSbqJUqFRIqoCULz1UKiRVQMrzcfUcAaSNY+fJQBY2dYcBaT+2oHR+YuiWCM7Y3P9f2owDGjgO4KgVyQEzmxH2Bz14VUBqeLIvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/Bolus.png
// module id = 305
// module chunks = 7